import DxyModal from './dxy-modal'
DxyModal.install = function (Vue) {
  Vue.component(DxyModal.name, DxyModal)
}
export default DxyModal
